export const INITIAL_STATE = {
    merchantGroupId: '',
    groupName: 'CUSTOM',
    description: '',
    imageUrl: '',
    merchantIds: [],
    loading: false,
    success: false,
    validated: false,
    merchants: [],
    merchantsLoading: false,
    imageUrlError: null,
    groupNameError: null,
    descriptionError: null,
    merchantIdError: null,
    merchantGroupIdError: null,
}

export const RESPONSE_MESSAGE = 'Category created successfully';

export const TOAST_MESSAGES = {
    success: 'Merchant group created successfully!',
    error: 'Failed to create merchant group. Please try again.',
    merchantsError: 'Failed to load merchants. Please refresh and try again.',
};

export const VALIDATION_ERROR_MESSAGES = {
    groupName: 'Group Name is required',
    merchantGroupId: 'Merchant Group ID is required',
    description: 'Description is required',
    imageUrl: 'Image URL must start with https://',
    imageUrlRequired: 'Image URL is required',
    merchantId: 'Please select at least one merchant',
};

export const MERCHANT_GROUP_FORM_FIELDS = [
    {
        name: 'merchantGroupId',
        label: 'Merchant Group ID',
        type: 'text',
        placeholder: 'Enter merchant group ID',
        required: true,
        validationMessage: 'Please provide a merchant group ID.',
    },
    {
        name: 'groupName',
        label: 'Group Name',
        type: 'text',
        placeholder: 'Enter merchant group name',
        required: true,
        validationMessage: 'Please provide a group name.',
    },
    {
        name: 'description',
        label: 'Description',
        type: 'textarea',
        placeholder: 'Enter group description',
        required: true,
        validationMessage: 'Please provide a description.',
        rows: 3,
    },
    {
        name: 'imageUrl',
        label: 'Image URL',
        type: 'text',
        placeholder: 'https://example.com/image.png',
        required: true,
        validationMessage: 'Image URL must start with https://',
    },
]